export default __webpack_public_path__ + "static/media/feet.00678df7.jpg";